<ifc-base-dialog [title]="title"
                 [actions]="actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <div class="container">
      <form *ngIf="loans.length">
        <mat-form-field appearance="outline"
                        *ngFor="let loan of loans">
          <mat-label>Account</mat-label>
          <input matInput
                 type="text"
                 [value]="loan.description"
                 [disabled]="true">
        </mat-form-field>
      </form>

      <ifb-customer-loan-input [fc]="form.get('loanNumber')"
                               [label]="'Search for account'"
                               [excludedStatus]="excludedStatus"
                               (autocompleteOptionSelected)="selectedLoan($event)"
                               [customerId]="data.customerId">
      </ifb-customer-loan-input>
    </div>
  </ng-template>
</ifc-base-dialog>
